/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <!-- 内容区域 -->
      <div class="cssystempage" ref="cssystemPage" :style="{ height: bodyHeight + 'px' }">
        <Row :gutter="20">
          <i-col span="6">
            <div class="leftbox" :style="{ height: bodyHeight + 'px' }">
              <div class="linehr"></div>
              <Spin v-if="treeLoading" fix>
                <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
                <div>菜单加载中...</div>
              </Spin>
              <Input
                style="width: 90%; flex: none"
                v-model="seachCName"
                @on-enter="getTreeInfo"
                class="tabdiv"
                placeholder="搜索企业"
              >
                <span slot="append" @click="getTreeInfo"><Icon type="ios-search-outline" /></span>
              </Input>

              <div class="treedivbox">
                <el-tree
                  ref="treeBox"
                  node-key="keyID"
                  :data="treeData"
                  :default-expanded-keys="expandedKeys"
                  :props="defaultProps"
                  :highlight-current="true"
                  :render-content="renderContent"
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
          </i-col>
          <i-col span="18">
            <div class="rightdivbox" :style="{ height: bodyHeight + 'px' }">
              <div class="company_text">{{ companyName || '' }}</div>
              <div class="rightbox">
                <div class="boxinterval">
                  <div class="realtop">
                    <div class="realtext">实时工况</div>
                    <div class="timesline">
                      <Icon class="iconclock" type="md-time" />
                      监测时间：{{ gkNowData.time || '离线' }}
                    </div>
                  </div>
                  <div class="statusinfo" ref="statusinfo">
                    <div class="statusimage">
                      <div class="productionbox">
                        <div class="productiontype" :style="{ color: textColor }">{{ productText }}</div>
                        <img :src="productionLine" />
                      </div>
                      <!-- <div class="leftimage">
                        <img :src="nowProPic" alt="" />
                      </div> -->
                      <div class="rightimage">
                        <img :src="nowscxPic" alt="" />
                      </div>
                    </div>
                    <div class="statusrightinfo" :style="{ height: realHeight }" v-if="realTimeList.length > 0">
                      <div class="iteminfo" v-for="(item, index) in realTimeList" :key="index">
                        <div class="leftitem">
                          <!-- item_normal item_warn -->
                          <div class="item_img" :class="item.status == 0 ? 'item_normal' : 'item_warn'">
                            <i :class="item.icon"></i>
                          </div>
                          <div class="item_text">{{ item.cn_name }}</div>
                        </div>
                        <div class="rightitem warningColor" v-if="item.status == 1">
                          {{ item.value }}{{ item.unit }}
                          <i class="icon iconfont icon-down" style="font-size: 14px" />
                        </div>
                        <div class="rightitem warningColor" v-else-if="item.status == 2">
                          {{ item.value }}{{ item.unit }}
                          <i class="icon iconfont icon-up-copy" style="font-size: 14px" />
                        </div>
                        <div class="rightitem" v-else>{{ item.value }}{{ item.unit }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 日曲图 -->
                <div class="boxinterval radiusdiv">
                  <div class="daybrokeline">
                    <div class="brokeleft">
                      <div class="broketext">日曲图</div>
                      <DatePicker
                        v-model="tableTime"
                        type="date"
                        placeholder="请选择时间"
                        :editable="false"
                        format="yyyy-MM-dd"
                        style="width: 130px"
                        @on-change="searchTime"
                      />
                      <div class="optionlist">
                        <RadioGroup v-model="btnFlag" @on-change="changeOption">
                          <template v-for="(item, index) in monitorList">
                            <Radio :label="item.codeId" :key="index"
                              ><span :class="btnFlag == item.codeId ? 'rideospan' : ''">{{ item.cnName }}</span></Radio
                            >
                          </template>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                  <div class="daybrokentable">
                    <Spin v-if="dataInfoLoading" fix>
                      <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
                      <div>加载中...</div>
                    </Spin>
                    <div ref="dayBrokenTable" v-if="dayNullData"></div>
                    <nullData v-else></nullData>
                  </div>
                </div>
                <!-- 历史工况 -->
                <div class="boxinterval radiusdiv">
                  <div class="historybox">
                    <div class="historyleft">
                      <div class="historytext">历史在线</div>
                      <div>
                        <!-- 切换历史时间 -->
                        <historyTimeChange
                          :yearTime="yearName"
                          :createTime="createTime"
                          @sendChangeTime="changeYear"
                        ></historyTimeChange>
                      </div>
                    </div>
                    <div class="historyright">
                      <DatePicker
                        placement="top-end"
                        v-model="timeRange"
                        type="datetimerange"
                        placeholder="请选择时间"
                        :editable="false"
                        format="yyyy-MM-dd"
                        style="width: 200px; margin-right: 10px"
                      />
                      <Button type="primary" ghost @click="exportFile"><i class="iconfont icon-daochu"></i>导出</Button>
                    </div>
                  </div>

                  <!-- 数据表格 -->
                  <i-table width="100%" stripe :columns="columns2" :data="gkTableList" :loading="tbLoading" />
                  <!-- 分页 -->
                  <Page
                    style="margin-top: 0.625rem"
                    show-total
                    :current.sync="page"
                    :page-size-opts="[20, 50, 100, 200]"
                    :page-size="row"
                    :total="total"
                    show-sizer
                    @on-change="onNextPage"
                    @on-page-size-change="onPageSize"
                  />
                </div>
              </div>
            </div>
          </i-col>
        </Row>
      </div>
    </X-Layout>
  </div>
</template>

<script>
// 历史年选择
import historyTimeChange from '@/components/historyTimeChange.vue';
import tableLine from '@/pages/echartsTable/table-line';
import 'element-ui/lib/theme-chalk/index.css';
import { downfile, formatDateTime2, formatDateTime1, formatDateTime3 } from '@/common/common.js';
import echarts from 'echarts';
import { getElementVale, mathEleHeight, createCompanyTime, exportExcel, overMonth } from '@/utils/common.js';
import { parseTime } from '@/utils/date.js';
import nullData from '@/components/nullData.vue';
export default {
  components: {
    tableLine,
    nullData,
    historyTimeChange,
  },
  data() {
    return {
      textColor: '#999999',
      productText: '未安装生产线检测设备',
      productionLine: require('@/assets/weianzhang.gif'),
      timeFlag: true, // true 可以启动定时器
      createTime: '', // 公司创建时间
      compnayId: '', // 当前选中的公司id
      yearName: '', // 历史在线时间
      todayYear: '',
      searchHistoryTime: '', // 搜索历史在线的时间
      dayCacheList: [], // 存放缓存数据
      dayTimeIndex: 0, // 日曲线图测点下标
      dayTableTime: '', // 自动切换日曲线图定时器
      dayNullData: true, // 日曲线图是否有数据
      bodyHeight: '', // 主框的高度
      dayCurveList: [], // 日曲线图数据
      formatime: '',
      realHeight: '300px',
      animal: '',
      echart: '',
      companyName: '', // 公司名
      labelTime: formatDateTime1(new Date()), // 获取当前时间
      tableTime: formatDateTime2(new Date()), // 表格时间
      btnFlag: '', // 默认被选中的按钮
      unit: '', // 检测项的单位
      monitName: '', // 检测项的名字
      monitorList: [], // 图表数据
      timeRange: [], //
      activeVal: 'name1', // 被选中的选项
      checkId: '', // 当前树行菜单选中的id
      realTimeList: [], // 实时数据
      defaultProps: {
        // 设置树菜单的接受格式
        children: 'siteid_list',
        label: 'title',
      },
      expandedKeys: [], // 指定树菜单展开key
      treeLoading: false, // 树菜单加载动画
      dataInfoLoading: false, // 信息加载动画
      gkNowData: {
        // 实时工况数据
        time: '离线', // 监测时间
        pro: '', // 生产线状态
        rkyl: '', // 入口压力
        fjdl: '', // 风机电流
        ckyl: '', // 出口压力
        url: [], // 现场照片
        ckwd: '', // 出口温度
        fs: '', // 风速
      },
      proshow: 2,
      nowProPic: '/images/hong1.png?v=2',
      nowscxPic: '/images/hong2.gif?v=2',
      gkNowpic: {
        // 实时工况图片
        pro: '', // 生产线状态
        rkyl: '', // 入口压力
        fjdl: '', // 风机电流
        ckyl: '', // 出口压力
      },
      gkSite_id: '', // 排口id
      listindex: '', // 删除数组中的第几个数据
      seachCName: '', // 搜索企业名
      comids: null, // 传入公司id
      tbLoading: false, // 数据表的加载动画开关
      total: 0, // 总条数
      page: 1, // 默认第一页
      row: 20, // 每页多少条
      treeData: [], // 树菜单数据
      columns2: [
        // 表格列名
      ],
      gkTableList: [], // 工况表格数据
    };
  },
  destroyed() {
    window.onresize = '';
    clearInterval(this.dayTableTime);
  },
  mounted() {
    // 获取当年年份
    this.yearName = this.todayYear = Number(parseTime(new Date(), '{y}'));
    this.comids = this.$route.params.id ? this.$route.params.id : null; // 得到 有传入公司的ID
    this.getTreeInfo(); // 执行初始化树菜单
    window.onresize = () => {
      if (this.dayNullData) {
        this.echart.resize();
      }

      // 获取元素的宽度
      this.getRealWidth();
      this.getBodyHeight();
    };
    this.$nextTick(() => {
      this.getBodyHeight();
      this.getRealWidth();
    });
  },
  methods: {
    changeYear(e) {
      this.yearName = e;
      this.page = 1;
      this.getGKHistoryInfo();
    },
    // 获取框的高度
    getBodyHeight() {
      // 获取div的高度
      this.bodyHeight = mathEleHeight(this.$refs.cssystemPage, 20);
    },
    getRealWidth() {
      let w = getElementVale(this.$refs.statusinfo, 'width');
      if (w >= 1100) {
        this.realHeight = '300px';
      } else {
        this.realHeight = '';
      }
    },
    // 选择测试项
    changeOption() {
      for (let i = 0; i < this.monitorList.length; i++) {
        const element = this.monitorList[i];
        if (element.codeId == this.btnFlag) {
          this.unit = element.unit;
          this.monitName = element.cnName;
          this.dayTimeIndex = i;
          break;
        }
      }
      this.timeFlag = false;
      this.getYYNowInfo();
    },
    // 初始化图表
    initEcharts(dataList, dataTime, statusList) {
      this.echart = echarts.init(this.$refs.dayBrokenTable);
      this.echart.clear();

      this.echart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#FFFFFF',
          extraCssText: 'box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);',
          padding: 10,
          textStyle: {
            // 提示框浮层的文本样式。
            color: '#233C52',
            fontSize: 12,
          },
          formatter: res => {
            let opt = '';
            let status = 0;
            let icon = '';
            for (let i = 0; i < res.length; i++) {
              const element = res[i];
              if (i == 0) {
                opt += `<div>${this.formatime} ${element.axisValue}</div>`;
                status = statusList[element.dataIndex];
                if (status == 1) {
                  icon = '<i class="icon iconfont icon-down" style="font-size: 10px"/>';
                } else if (status == 2) {
                  icon = '<i class="icon iconfont icon-up-copy" style="font-size: 10px" />';
                }
              }

              opt += `<div><span>${element.seriesName}</span>：<span style="color:${
                status == 0 ? element.color : '#E72D14'
              }" >${element.value}${this.unit}${icon}</span></div>`;
            }
            return opt;
          },
        },
        color: ['#2db7f5'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataTime,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#aaaaaa',
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#aaaaaa',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#E1E2E7'],
              width: 1,
              type: 'deshad',
            },
          },
        },
        series: [
          {
            name: this.monitName,
            type: 'line',
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 5, //设置线条粗细
                },
              },
            },
            smooth: true,
            data: dataList,
          },
        ],
      });
      setTimeout(() => {
        this.echart.resize();
      }, 100);
    },
    // 时间搜索
    searchTime() {
      this.getYYNowInfo();
    },
    // 按钮被选中事件
    checkBtn(num, opt, unit) {
      this.btnFlag = num;
      this.monitName = opt;
      this.unit = unit;
      // 获取当前检测项的数据
      this.getYYNowInfo();
    },
    /**
     * 树菜单使用的render 使用自定义格式 返回对应的样式
     */
    renderContent: function (h, { node, data, store }) {
      switch (
        data.level // 判断树菜单层级
      ) {
        case 1: // 第1层 公司需要显示数量 报警变色
          if (data.warnStatus === 1) {
            // 判断公司报警状态
            return (
              <span style="font-size: 14px;color:red;">
                {' '}
                <i class={data.icon}> </i>
                <Badge count={data.num1}>
                  <span style="padding-left: 4px;">{node.label}</span>
                </Badge>
              </span>
            );
          } else {
            return (
              <span style="font-size: 14px;">
                {' '}
                <i class={data.icon}> </i>
                <span style="padding-left: 4px;">{node.label}</span>{' '}
              </span>
            );
          }
        case 2: // 第2层 排口不需要显示数量 报警变色
          if (data.status === 1 || data.status === 2) {
            // 判断排口报警状态
            return (
              <span style="font-size: 14px;color:red;">
                {' '}
                <i class={data.icon}> </i>
                <span style="padding-left: 4px;">{node.label}</span>{' '}
              </span>
            );
          } else {
            return (
              <span style="font-size: 14px;">
                {' '}
                <i class={data.icon}> </i>
                <span style="padding-left: 4px;">{node.label}</span>{' '}
              </span>
            );
          }
      }
    },
    /**
     * 渲染树菜单 根据树菜单要求处理传入得到list数据
     */
    handleTreeList(list) {
      const _warrSite_ids = []; // 用于记录传入公司id时 记录所有报警排口的id集合
      const compayNameList = []; // 记录公司名
      let historyTime = ''; // 公司时间
      // 处理得到数据 添加上树菜单需要的字段
      for (let i = 0; i < list.length; i++) {
        // 添加1级数菜单
        list[i].title = list[i].company_name; // 新添title字段 树菜单显示标题
        list[i].icon = 'icon iconfont icon-gongchang'; // 新添icon字段 企业图标
        list[i].level = 1; // 添加层级 当前第1层 用于点击事件判断用
        list[i].keyID = '1' + list[i].company_id; // 添加一个唯一ID 用于展开使用 ；   '1'+ 是为了 1层和2层没有相同的ID

        // 处理2级菜单 判断一下是否有siteid_list节点
        if (list[i].siteid_list) {
          // 循环第二级数据 添加数据
          for (let j = 0; j < list[i].siteid_list.length; j++) {
            list[i].siteid_list[j].title = list[i].siteid_list[j].gkSite_name; // 新添title字段 树菜单显示标题 2级
            list[i].siteid_list[j].parentName = list[i].company_name; // 父节点的名字
            list[i].siteid_list[j].icon = 'icon iconfont icon-wuranyuan'; // 新添icon字段 排口图标
            list[i].siteid_list[j].level = 2; // 添加层级 当前第2层 用于点击事件判断用
            list[i].siteid_list[j].keyID = '2' + list[i].siteid_list[j].gkSite_id; // 添加一个唯一ID 用于展开使用 ；  '2'+ 是为了 1层和2层没有相同的ID
            list[i].siteid_list[j].keyTime = list[i].time ? parseTime(list[i].time, '{y}') : '';
            list[i].siteid_list[j].compnayId = list[i].company_id;
            // 记录报警排口
            if (this.comids === list[i].company_id) {
              // 先判断是否传入的当前公司id
              if (list[i].siteid_list[j].status === 1) {
                // 判断当前排口为报警状态
                _warrSite_ids.push(list[i].siteid_list[j].gkSite_id); // 记录排口id
                compayNameList.push(list[i].company_name + ' - ' + list[i].siteid_list[j].gkSite_name);
              }
            }
          }
        }

        // 判断上面记录的 报警排口集合 如果是空的话 代表该公司下没有报警排口 那就默认第一个排口
        if (this.comids === list[i].company_id) {
          // 判断如果传入的公司id 等于 当前2层的公司id
          if (_warrSite_ids.length === 0) {
            _warrSite_ids.push(list[i].siteid_list[0].gkSite_id);
            compayNameList.push(list[i].company_name + ' - ' + list[i].siteid_list[0].gkSite_name);
            historyTime = list[i].siteid_list[0].keyTime;
            this.compnayId = list[i].siteid_list[0].compnayId;
          }
        }
      }
      this.treeData = list; // 处理好的list赋值树菜单渲染
      // 判断是否 有传入公司ID 代表是首页跳转进来的
      if (this.comids) {
        this.expandedKeys.push('1' + this.$route.params.id); // 展开节点  '1'+ 是区分是1层
        this.$nextTick(() => {
          // 设置选中节点  treeBox 元素的ref
          this.$refs.treeBox.setCurrentKey('2' + _warrSite_ids[0]); // 取报警记录集合中的第1个排口id
        });
        this.gkSite_id = _warrSite_ids[0]; // 取报警记录集合中的第1个排口id
        this.companyName = compayNameList[0];
        this.createTime = historyTime;
      } else {
        // 默认设置第一个公司 节点和选中展开
        if (list[0]) {
          this.expandedKeys.push(list[0].keyID); // 展开第一个公司节点的keyid
          this.createTime = list[0].siteid_list[0].keyTime;
          this.compnayId = list[0].siteid_list[0].compnayId;
          this.$nextTick(() => {
            // 设置选中节点  treeBox 元素的ref
            this.$refs.treeBox.setCurrentKey(list[0].siteid_list[0].keyID);
          });
          this.gkSite_id = list[0].siteid_list[0].gkSite_id; // 设置默认第一个公司 第一个排口id
          this.companyName = list[0].company_name + ' - ' + list[0].siteid_list[0].gkSite_name;
        }
      }
    },

    /**
     * 初始化 树菜单信息
     */
    getTreeInfo() {
      const api = this.ApiUrl + 'nowData/findAllGk';
      const params = {
        companyName: this.seachCName || '',
      };
      this.treeLoading = true; // 开启加载动画
      this.dataInfoLoading = true; // 把信息页加载动画也开启
      // 请求接口
      this.$http.get(api, { params }).then(
        res => {
          if (res.data.extend.news === 0) {
            var list = res.data.extend.pageInfo;
            // 获取第一个渲染的id
            if (list.length > 0 && list[0].siteid_list.length > 0 && list[0].siteid_list[0].gkSite_id) {
              this.checkId = list[0].siteid_list[0].gkSite_id;
              this.companyName = list[0].company_name + ' - ' + list[0].siteid_list[0].gkSite_name;
            }

            this.handleTreeList(res.data.extend.pageInfo); // 1.渲染树菜单
            this.getGKNowInfo(); // 2.执行【实时数据】
            this.getYYNowInfo(); // 日曲线图
            // this.getGKHistoryInfo(); // 3.执行初始化表格数据 【历史数据】
          }
          this.treeLoading = false; // 开启加载动画
        },
        res => {
          this.treeLoading = false; // 开启加载动画
        },
      );
    },
    /**
     * 树菜单单击事件
     */
    handleNodeClick(data) {
      // 如果是第2层 就触发 表格事件
      if (data.level == 2) {
        this.timeFlag = true;
        this.productText = '未安装生产线检测设备';
        this.textColor = '#999999';
        this.productionLine = require('@/assets/weianzhang.gif');
        this.gkTableList = []; // 清空数据表
        this.realTimeList = []; // 清空实时数据
        this.gkNowData = {
          // 清空实时工况数据
          time: '离线', // 监测时间
          url: [], // 现场照片
        };
        this.compnayId = data.compnayId;
        this.gkSite_id = data.gkSite_id; // 设置选中排口Id
        this.companyName = data.parentName + ' - ' + data.gkSite_name; // 公司名
        this.btnFlag = ''; // 初始化检测项
        this.page = 1; // 初始化 设置第一页
        // 初始化时间
        this.yearName = this.todayYear;
        // 遍历当前时间
        this.createTime = data.keyTime;
        // this.row = 20; // 初始化 20条数据
        this.total = 0; // 初始化 总条数
        this.getGKNowInfo(); // 执行【实时数据】
        this.getYYNowInfo(); // 日曲线图
        this.getGKHistoryInfo(); // 【历史数据】渲染表格
      }
    },

    /**
     * 表格数据
     */

    getYYNowInfo() {
      const apis = 'gkData/getGkDataBySiteIdCodeIdAndTime';
      this.data = {
        gkSiteId: this.gkSite_id, // 排口id
        codeId: this.btnFlag || 0, // 检测项的id
        day: formatDateTime2(this.tableTime), // 时间
        type: 0, // 0 工况  1 油烟  2在线
      };
      this.dayCurveList = [];
      this.dataInfoLoading = true; // 开启加载动画
      // 开启请求
      this.$http
        .post(this.ApiUrl + apis, this.data)
        .then(res => {
          if (res.data.extend.news == 0) {
            // 图表数据
            const dataList = [];
            let dataTime = [];
            let statusList = [];
            const list = res.data.extend.dataList;
            this.dayCurveList = list;
            for (let i = 0; i < list.length; i++) {
              // 获取当天的实时数据
              if (list[i].value) {
                dataList.push(list[i].value * 1);
                dataTime.push(list[i].receive_time ? parseTime(list[i].receive_time, '{h}:{i}') : '');
                statusList.push(list[i].status);
              } else {
                dataList.push(0);
              }
            }
            // 将数据赋给图表数据
            // this.labelList = dataList
            // 获取监控项
            if (res.data.extend.codeMapList && res.data.extend.codeMapList.length > 0) {
              this.monitorList = res.data.extend.codeMapList;

              // 被选中的监控项如果没有值就将第一个值赋给他
              if (!this.btnFlag) {
                this.btnFlag = res.data.extend.codeMapList[0].codeId;
                this.unit = res.data.extend.codeMapList[0].unit;
                this.monitName = res.data.extend.codeMapList[0].cnName;
                this.dayTimeIndex = 0;
                this.dayCacheList = [];
              }

              // 定时切换定时器
              if (this.monitorList.length > 1) {
                this.dayTimeTable();
              }
            }
            // 判断是否要暂停定时器
            if (!this.timeFlag) {
              if (this.dayTableTime) {
                clearInterval(this.dayTableTime);
              }
            }

            this.formatime = parseTime(this.tableTime || new Date(), '{y}-{m}-{d}');
            this.dayCacheList[this.dayTimeIndex] = {
              dataList,
              dataTime,
              statusList,
            };
            if (dataList.length == 0 && dataTime.length == 0) {
              this.dayNullData = false;
            } else {
              this.dayNullData = true;
              this.$nextTick(() => {
                this.initEcharts(dataList, dataTime, statusList);
              });
            }
          }

          this.dataInfoLoading = false; // 关闭加载动画
        })
        .catch(err => {
          this.dataInfoLoading = false; // 关闭加载动画
        });
    },
    // 定时切换定时器
    dayTimeTable() {
      if (this.dayTableTime) {
        clearInterval(this.dayTableTime);
      }

      this.dayTableTime = setInterval(() => {
        if (this.monitorList.length - 1 > this.dayTimeIndex) {
          this.dayTimeIndex++;
        } else {
          this.dayTimeIndex = 0;
        }
        let info = this.monitorList[this.dayTimeIndex];
        this.btnFlag = info.codeId;
        this.unit = info.unit;
        this.monitName = info.cnName;
        let infodata = this.dayCacheList[this.dayTimeIndex];
        if (infodata && infodata.dataList) {
          if (infodata.dataList.length == 0 && infodata.dataTime.length == 0) {
            this.dayNullData = false;
          } else {
            this.dayNullData = true;
            this.$nextTick(() => {
              this.initEcharts(infodata.dataList, infodata.dataTime, infodata.statusList);
            });
          }
        } else {
          this.getYYNowInfo();
        }
      }, 5000);
    },
    show4(e) {},
    /**
     * 得到工况 【实时数据】
     */
    getGKNowInfo() {
      //
      const apis = 'gkData/findByGkSiteId2'; // 请求接口

      const data = {
        // 请求参数
        time: this.formatDateTime1(new Date()), // 取得当前日期
        gkSite_id: this.gkSite_id,
        page: this.page,
        row: this.row,
      };
      // 实时数据清空
      this.realTimeList = [];
      this.dataInfoLoading = true; // 开启加载动画
      // 开启请求
      this.$http.post(this.ApiUrl + apis, data).then(
        res => {
          if (res.data.extend.news === 0 && res.data.extend.lxStatus === 0) {
            // 赋值标图数据
            const list = res.data.extend.pageInfo;
            this.realTimeList = res.data.extend.pageInfo;

            //处理放空阀状态 0:关 1:开
            for (const res of this.realTimeList) {
              console.log(res.cn_name);
              if (res.cn_name == '放空阀状态') res.value = parseInt(res.value.toString().trim()) == 0 ? '关' : '开';
            }

            this.gkNowData.time = this.formatDateTime(list[0].receive_time); // 监测时间
            // 判断生产线状态

            list.forEach((item, index) => {
              switch (item.code_name) {
                case 'g208': // 引风机电流
                  if (parseFloat(item.value.trim()) > 0.1) {
                    // 电流超过0.1A 就属于开启
                    this.nowscxPic = '/images/lv2.gif?v=2';
                  } else {
                    this.nowscxPic = '/images/hong2.gif?v=2';
                  }
                  break;
              }

              // 获取当前生产线的状态 0 生产中 1 关机中 2未安装 3离线中
              console.log('index', index);
              if (index == 0) {
                console.log('item.pro', item.pro);
                switch (item.pro) {
                  case 0:
                    this.productText = '生产线运行中';
                    this.textColor = '#76B4FD';
                    this.productionLine = require('@/assets/working.gif');
                    break;
                  case 1:
                    this.productText = '生产线停工中';
                    this.textColor = '#76B4FD';
                    this.productionLine = require('@/assets/nowork.gif');
                    break;
                  case 2:
                    this.productText = '未安装生产线检测设备';
                    this.textColor = '#999999';
                    this.productionLine = require('@/assets/weianzhang.gif');
                    break;
                  case 3:
                    this.productText = '生产线设备离线';
                    this.textColor = '#999999';
                    this.productionLine = require('@/assets/meixinghao.gif');
                    break;
                }
              }
            });

            // 【实时数据】现场图片
            const picUrl = res.data.extend.picUrl;
            if (picUrl === null || picUrl.picUrl == '') {
              this.gkNowData.url = [
                {
                  url: '/images/nopic.gif',
                },
              ]; // 默认没有图片显示系统设置图片
            } else {
              this.gkNowData.url = []; // 先清空
              if (picUrl.picUrl.match(',')) {
                picUrl.picUrl.split(',').forEach(element => {
                  this.gkNowData.url.push({
                    url: element,
                  });
                });
              } else {
                const url = {
                  url: picUrl,
                };
                this.gkNowData.url.push(url);
              }
            }
          } else {
            this.proshow = 5;
            // this.nowProPic = '/images/hong1.gif';
            this.nowscxPic = '/images/hong2.gif?v=2';
          }
          this.dataInfoLoading = false; // 关闭加载动画
        },
        res => {
          this.dataInfoLoading = false; // 关闭加载动画
        },
      );
    },
    /**
     * 得到工况 【历史数据】  渲染表格
     */
    getGKHistoryInfo() {
      //
      const apis = 'gkData/findHistoryData'; // 请求接口

      const data = {
        // 请求参数
        gkSite_id: this.gkSite_id,
        page: this.page,
        row: this.row,
        time: this.yearName + '',
      };
      this.tbLoading = true; // 开启加载动画
      this.columns2 = [];
      this.gkTableList = [];
      this.total = 0;

      // 开启请求
      this.$http
        .post(this.ApiUrl + apis, data)
        .then(res => {
          if (res.data.extend.news === 0) {
            // 表中数据
            this.columns2 = [];
            this.columns2.push({
              type: 'index',
              title: '序号',
              align: 'center',
              minWidth: 90,
              indexMethod: row => {
                return row._index + 1 + this.page * this.row - this.row;
              },
            });
            this.gkTableList = res.data.extend.dataList;

            //处理放空阀状态 0:关 1:开
            for (const itme of this.gkTableList) {
              for (const res of itme.data) {
                if (res.name == '放空阀状态') res.value = parseInt(res.value.toString().trim()) == 0 ? '关' : '开';
              }
            }

            var titleList = ''; // 存放表头数据
            if (res.data.extend.tableTitle && res.data.extend.tableTitle.length > 0) {
              titleList = res.data.extend.tableTitle;
            }

            for (var i = 0; i < titleList.length; i++) {
              let fiexdDir = '';
              if (titleList[i] == '监测时间') {
                fiexdDir = 'right';
              }
              this.columns2.push({
                title: titleList[i],
                align: 'center',
                fixed: fiexdDir,
                minWidth: fiexdDir ? 180 : 130,
                render: (h, params) => {
                  let _class = '';
                  let _class1 = '';
                  let opt = '';
                  let statuflag = '';
                  // 对比有无对应数据
                  const res = params.row.data.find(values => {
                    return values.name == params.column.title;
                  });
                  // 有对应数据

                  if (res) {
                    // 状态
                    statuflag = res.status;
                    // 数值
                    opt = res.value;
                  }
                  switch (
                    statuflag // 判断值 设置对应的样式
                  ) {
                    case 1:
                      _class = 'demo-table-info-cell-value';
                      _class1 = 'icon iconfont icon-down demo-table-info-cell-value';
                      break;
                    case 2:
                      _class = 'demo-table-info-cell-value';
                      _class1 = 'icon iconfont icon-up-copy demo-table-info-cell-value';
                      break;
                  }
                  return h('div', [h('span', { class: _class }, opt), h('i', { class: _class1 })]);
                  // }
                },
              });
            }
            this.total = res.data.extend.total; // 设置总页数
          } else {
            this.total = 0;
          }
          this.tbLoading = false; // 关闭加载动画
        })
        .catch(err => {
          this.total = 0;
          this.tbLoading = false; // 关闭加载动画
          this.columns2 = [];
          this.gkTableList = [];
        });
    },
    // 被选中项的事件(实时name1 日曲线name3 历史name2)
    checkedTab() {
      if (this.activeVal == 'name1') {
        if (this.realTimeList.length <= 0) {
          this.getGKNowInfo();
        }
      } else if (this.activeVal == 'name2') {
        if (this.gkTableList.length <= 0) {
          this.getGKHistoryInfo();
        }
      } else if ((this.activeVal = 'name3')) {
        if (this.monitorList.length <= 0) {
          this.getYYNowInfo();
        }
      }
    },
    /**
     * 切换显示的页数
     * */
    onPageSize(e) {
      this.row = e;
      this.getGKHistoryInfo(); // 执行工况【历史数据】数据表
    },
    // 导出文件
    exportFile() {
      if (!this.timeRange[0]) {
        this.$Message.warning('请选择时间段');
        return;
      }

      if (!this.gkSite_id) {
        this.$Message.warning('请选择排口');
        return;
      }

      // 不要超过四个月
      if (!overMonth(this.timeRange[0], this.timeRange[1], 12)) {
        this.$Message.warning('选择的日期请不要超过12个月');
        return;
      }

      exportExcel(this.compnayId, this.gkSite_id, this.timeRange[0], this.timeRange[1], this);
    },
    /**
     * 切换下一页
     */
    onNextPage(e) {
      this.page = e;
      this.getGKHistoryInfo(); // 执行工况【历史数据】数据表
    },
    // 刷新页面
    reload() {
      location.reload();
    },
  },
};
</script>
<style lang="scss">
.cssystempage {
  .ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }
  .ivu-col-span-18 {
    padding-left: 5px !important;
  }
}
</style>
<style scoped lang="scss">
/deep/ .ivu-badge-count {
  right: -9px !important;
  top: -4px;
  background-color: #ff5b5b;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 16px;
  min-width: 16px;
  padding: 0 4px;
  z-index: 10;
}
</style>
<style scoped lang="scss">
.cssystempage {
  overflow: hidden;
  .leftbox {
    background: #fff;
    padding: 0 15px;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-top: 20px;
    .linehr {
      height: 6px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background-color: #0062ff;
      border-radius: 8px 8px 0 0;
    }
    .treedivbox {
      flex: 1;
      overflow-y: auto;
    }
    // 滚动条宽高
    .treedivbox::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    // 滚动条背景颜色
    .treedivbox::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 5px;
    }
    // 滚动条颜色
    .treedivbox::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
    }
    // 鼠标移动到滚动条上颜色
    .treedivbox::-webkit-scrollbar-thumb:hover {
      background: rgb(122, 121, 121);
    }
  }

  .rightdivbox {
    display: flex;
    flex-direction: column;
  }
}

.ivu-table {
  font-size: 14px;
}

.topbtn {
  display: flex;
}

.crd {
  color: red !important;
}

.topbtn > div {
  margin-right: 20px;
}

.divday {
  margin-top: 2px;
}

.divday > button {
  margin-right: 5px;
}

.timebox {
  margin-top: 2px;
}

.gkNow {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 18px 24px;
  background-color: #fafafa;
  border: 1px solid #eaeefb;
  margin-bottom: 25px;
  border-radius: 4px;
  text-align: center;
}
/* .gkNow::-webkit-scrollbar {
  display: none;
} */
.gkNow > div {
  min-width: 1020px;
}

.gkNow i {
  font-size: 130px;
}

.gkNow .ctime {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 4px auto;
  font-size: 14px;
}

.changbox > button {
  border-radius: 0;
  padding-left: 30px;
  padding-right: 30px;
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.imgbox {
  padding-top: 2.5rem;
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.imgbox img {
  width: 6.25rem;
  height: 6.25rem;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-bottom: 20px;
  width: 80%;
  position: relative;
  z-index: 1;
}

.comname {
  padding: 10px 0;
  display: block;
  color: #cccccc;
}

.boxStatus {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 12px auto;
  font-size: 14px;
  line-height: 26px;
}

.normal {
  background-color: #19be6b;
}

.exceed {
  background-color: #ed4014;
}
.searTime {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  justify-content: flex-end;
}
.searTime > div {
  margin-right: 10px;
}
.company_text {
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  color: #0062ff;
  position: relative;
  height: 35px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1px;
  border-radius: 8px 8px 0 0;
}

.boxinterval {
  background: #fff;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 0 0 8px 8px;
}
.radiusdiv {
  border-radius: 8px;
}
// 滚动条宽高
.rightbox::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
// 滚动条背景颜色
.rightbox::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 5px;
}
// 滚动条颜色
.rightbox::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
// 鼠标移动到滚动条上颜色
.rightbox::-webkit-scrollbar-thumb:hover {
  background: rgb(122, 121, 121);
}
.rightbox {
  overflow-y: auto;
  flex: 1;
  .realtop {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .realtext {
      display: flex;
      position: relative;
      padding-left: 14px;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      margin-right: 30px;
    }
    .realtext::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 4px;
      height: 14px;
      background-color: #0062ff;
      transform: translateY(-50%);
    }
    .timesline {
      display: flex;
      padding: 6px 8px;
      background-color: #0062ff;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      border-radius: 4px;
      .iconclock {
        font-size: 15px;
        color: #fff;
        margin-right: 5px;
      }
    }
  }
  .statusinfo {
    background: #fafafa;
    padding: 10px;
    display: flex;
    overflow-x: auto;
    max-width: 100%;
    .statusimage {
      flex: none;
      display: flex;
      justify-content: center;
      min-width: 550px;
      height: 280px;
      .productionbox {
        width: 190px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        position: relative;
        > img {
          width: 100%;
          margin-bottom: 8px;
        }
        .productiontype {
          white-space: nowrap;
          position: absolute;
          font-size: 15px;
          font-weight: bold;
          bottom: -5px;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .leftimage {
        width: 83px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        > img {
          width: 100%;
        }
      }
      .rightimage {
        width: 370px;
        > img {
          width: 100%;
        }
      }
    }
    .statusrightinfo {
      flex: 1;
      display: flex;
      align-content: flex-start;
      flex-direction: column;
      flex-wrap: wrap-reverse;
      min-width: 320px;
      margin-top: 10px;
      margin-right: 10px;
      .iteminfo {
        box-shadow: 0 0 4px #d1d0d0;
        flex: none;
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        align-items: center;
        width: 255px;
        height: 85px;
        background: #f5f5f5;
        line-height: 1em;
        margin-bottom: 10px;
        margin-left: 10px;
        border-radius: 8px;
        .leftitem {
          display: flex;
          align-items: center;
          // #e72d14
          .item_img {
            width: 34px;
            height: 34px;
            margin-right: 10px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            > i {
              font-size: 20px;
              color: #fff;
            }
          }
          .item_normal {
            box-shadow: 0 0 5px 5px rgba(25, 190, 107, 0.6);
            background: #19be6b;
          }
          .item_warn {
            box-shadow: 0 0 5px 5px rgba(231, 45, 20, 0.6);
            background: #e72d14;
          }
          .item_text {
            font-size: 16px;
            font-weight: bold;
            line-height: 9px;
            color: #333333;
          }
        }
        .rightitem {
          font-size: 20px;
          font-weight: bold;
          color: #19be6b;
          line-height: 1em;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .daybrokeline {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
    .brokeleft {
      display: flex;
      align-items: center;
      .broketext {
        font-size: 16px;
        font-weight: bold;
        color: #233c52;
        position: relative;
        padding-left: 9px;
        margin-right: 36px;
      }
      .broketext::before {
        position: absolute;
        content: '';
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #0062ff;
      }
      .optionlist {
        margin-left: 20px;
      }
    }
  }
  .daybrokentable {
    height: 250px;
    width: 100%;
    position: relative;
    > div {
      width: 100%;
      height: 100%;
    }
  }
  .historybox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .historyleft {
      display: flex;
      align-items: center;
      .historytext {
        padding-left: 9px;
        position: relative;
        font-size: 16px;
        font-weight: bold;
        color: #233c52;
        margin-right: 20px;
      }
      .historytext::before {
        content: '';
        width: 4px;
        height: 16px;
        background: #0062ff;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
    .historyright {
      i {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
}

.btnList {
  height: 37px;
  display: flex;
  flex-wrap: nowrap;
  letter-spacing: 2px;
  justify-content: space-between;
}

.btnList > div {
  display: flex;
}
.btnList > div > div {
  margin-right: 5px;
}
.picboximg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  position: relative;
  top: 62px;
  margin-left: 130px;
}
.noData {
  flex: 1;
  font-size: 16px;
  color: #666;
  height: 75px;
  line-height: 75px;
  text-align: center;
}
.databox {
  display: flex;
  margin-top: 30px;
  margin-right: 30px;
  width: 100px;
}
.databox .nr {
  margin: 0 12px 0 26px;
}
.rideospan {
  color: #2d8cf0;
}
</style>
